import React from 'react';
import './Article.css';

const Article = () => {
    return (
        <main className='py-5 m-0'>
            <div className="container d-flex flex-column  align-items-center">
                <h1 className='articleTitle text-center'>BE A BETTER​ YOU</h1>
                <h1 className='articleTitle2 text-center'>PERSONAL TRAINING WITH IFAT</h1>
                <p className='articleParagraph my-3'>Whether you want to lose weight, tone up, gain lean muscle or you are happy as you are but would like a healthier lifestyle, Falcon  Fitness is the right choice for you. Everyone wants to feel comfortable in their own skin, therefore, even if you are working a busy schedule, finding it hard to meet your fitness goals or would like to get fit, I will give you the flexibility to reach your full potential with a variety of different online and individual personal training plans.</p>
            </div>
        </main>
    );
};

export default Article;